import { render } from "./Success.vue?vue&type=template&id=a5163ee4&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import "./Success.vue?vue&type=style&index=0&id=a5163ee4&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5163ee4"],['__file',"src/views/post/Success.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5163ee4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5163ee4', __exports__)) {
    console.log('reload')
    api.reload('a5163ee4', __exports__)
  }
  
  module.hot.accept("./Success.vue?vue&type=template&id=a5163ee4&scoped=true", () => {
    console.log('re-render')
    api.rerender('a5163ee4', render)
  })

}


export default __exports__